import {
  Button,
  Card,
  Col,
  Image,
  InputNumber,
  Modal,
  Popconfirm,
  Row,
  Select,
  Switch,
  Tabs,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useHttp from "../../../hooks/use-http";
import {
  apiGenerator,
  convertUTCToLocal,
  PERMISSION,
} from "../../../util/functions";
import CONSTANTS, {
  RenderEditButton,
  RenderToggleButton,
} from "../../../util/constant/CONSTANTS";
import ArrowIcon from "../../../component/common/ArrowIcon";
import { TfiWallet } from "react-icons/tfi";
import { EyeOutlined } from "@ant-design/icons";
import Transaction from "./tabs/Transaction";
import Task from "./tabs/Task";
import dummy_img from "../../../asset/image/dummy-avatar.jpg";
import WorkProof from "../../../component/taskApproval/WorkProof";
import AffiliateHistory from "./tabs/AffiliateHistory";
import ReferredUser from "./tabs/ReferredUser";
import RequestList from "./../withdrawal/Request";
import ModalFormCreator from "../../../component/common/ModalFormCreator";
import ReferredUserTask from "./tabs/ReferredUserTask";

const UserDetail = ({ admindetails, permissionId }) => {
  const accessPermission = +admindetails?.access
    ?.split(",")
    ?.filter((ele) => ele.includes(permissionId))[0]
    ?.split("-")[1];
  const [docList, setDocList] = useState(null);
  const [isDeviceBlock, setIsDeviceBlock] = useState(false);
  const [openResonModal, setOpenResonModal] = useState(null);
  const [userData, setUserData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const api = useHttp();
  const { id } = useParams();
  const navigate = useNavigate();

  const OnFormSubmitBtn = (res) => {
    const payload = {
      isBlocked: !!openResonModal,
      blockReason: res?.blockReason ?? "",
    };
    const UpdateAPIEnd = {
      ...CONSTANTS?.API.user.update,
    };
    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${openResonModal ?? res}`;
    api.sendRequest(
      UpdateAPIEnd,
      () => {
        setOpenResonModal(null);
        setRefresh((prev) => !prev);
      },
      payload,
      `User ${payload?.isBlocked ? "Blocked" : "Unblock"} Successfully`
    );
  };

  const menus = {
    transaction: <Transaction id={id} />,
    task: <Task id={id} />,
    affiliateHistory: <AffiliateHistory id={id} />,
    referredUser: <ReferredUser accessPermission={accessPermission} />,
    referredUserTask: <ReferredUserTask />,
    withdrawalRequest: <RequestList accessPermission={accessPermission} />,
  };
  useEffect(() => {
    const USER_DETAIL_API = apiGenerator(CONSTANTS.API.user.getOne, { id });

    api.sendRequest(USER_DETAIL_API, (res) => {
      setUserData(res?.data);
      if (res?.data?.deviceId)
        api.sendRequest(
          CONSTANTS.API.Device_Management.getAllDevice,
          (res) => {
            setIsDeviceBlock(res?.data?.rows?.[0]?.isBlocked);
          },
          {
            deviceId: res?.data?.deviceId,
          }
        );
    });
  }, [refresh]);

  const generateReferralCode = () => {
    api.sendRequest(
      apiGenerator(CONSTANTS.API.user.generateCode, { userId: id }),
      (res) => {
        setRefresh((pre) => !pre);
      },
      {},
      "Referral Generate Successfully"
    );
  };

  return (
    <>
      <div className="my-5">
        <Card>
          <div className="flex items-center gap-2">
            <ArrowIcon
              onClick={() => navigate(-1)}
              className={"cursor-pointer"}
              size={27}
            />
            <p className="font-medium text-2xl">User Personal Details </p>
          </div>

          <Row className="my-3">
            <Col span={8}>
              {/* Profile Pic */}
              <div>
                <Image
                  className="rounded-full"
                  width={60}
                  height={60}
                  src={userData?.image || dummy_img}
                  alt="user profile"
                />
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">User Name :&nbsp;</span>
                {userData?.name}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Mobile No. :&nbsp;</span>
                {userData?.countryCode} {userData?.mobile}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Device Id. :&nbsp;</span>
                {userData?.deviceId}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">
                  Task Commission Limit Per USer (₹) :&nbsp;
                </span>
                <InputNumber
                  className="w-20"
                  name="upperLimitOfReferralEarning"
                  value={userData?.upperLimitOfReferralEarning}
                  controls={false}
                  onBlur={(e) => {
                    const UpdateAPIEnd = { ...CONSTANTS?.API.user.update };
                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                    api.sendRequest(
                      UpdateAPIEnd,
                      () => {
                        setRefresh((prev) => !prev);
                      },
                      {
                        upperLimitOfReferralEarning: e.target.value
                          ? +e.target.value
                          : null,
                      },
                      `Commission Limit Updated Successfully`
                    );
                  }}
                  placeholder="Amount"
                />
                {}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Address Line 1 :&nbsp;</span>
                {userData?.addressLine1}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Address Line 2 :&nbsp;</span>
                {userData?.addressLine2}
              </div>
            </Col>
            <Col span={8}>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Wallet Balance :&nbsp;</span>
                {userData?.walletBalance || 0}
              </div>
              <div className="font-medium">
                <span className="text-[#A8B0B8]">Available Spin :&nbsp;</span>
                {userData?.spinAvailable || 0}
              </div>
              <div className="my-5  font-medium">
                <span className="text-[#A8B0B8]">Referral Code :&nbsp;</span>
                {userData?.myReferralCode ? (
                  userData?.myReferralCode
                ) : (
                  <>
                    <Popconfirm
                      title="Are you sure?"
                      onConfirm={() => generateReferralCode()}
                    >
                      <Button type="primary" size="small">
                        Generate
                      </Button>
                    </Popconfirm>
                  </>
                )}
              </div>
              <div className="my-5  font-medium">
                <span className="text-[#A8B0B8]">Reference Code :&nbsp;</span>
                {userData?.referenceCode}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Gender :&nbsp;</span>
                {userData?.gender}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Date od Birth :&nbsp;</span>
                {convertUTCToLocal(userData?.DOB, "DD/MM/YYYY")}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Email ID :&nbsp;</span>
                {userData?.email}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Total Refer :&nbsp;</span>
                {userData?.totalRefer || 0}
              </div>
              <div className="my-5  font-medium">
                <span className="text-[#A8B0B8]">
                  Total Task Submission :&nbsp;
                </span>
                {userData?.totalTaskSubmission || 0}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">
                  Total Approved Task :&nbsp;
                </span>
                {userData?.totalApprove || 0}
              </div>
            </Col>
            <Col span={8}>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">Total Amount :&nbsp;</span>
                {userData?.score || 0}
              </div>
              <div className="font-medium">
                <span className="text-[#A8B0B8]">Date of Account :&nbsp;</span>
                {convertUTCToLocal(userData?.createdAt)}
              </div>
              <div className="my-5 font-medium">
                <span className="text-[#A8B0B8]">IP Address :&nbsp;</span>
                {userData?.ipAddress}
              </div>

              <div className="my-5 font-medium flex  items-center gap-2">
                Task Auto Approval
                {RenderToggleButton({
                  checked: !userData?.isAutoApproval,
                  id: userData?.id,
                  isDisable: PERMISSION[accessPermission] === "READ",
                  size: "small",
                  onClick: (id, val) => {
                    const UpdateAPIEnd = { ...CONSTANTS?.API.user.update };
                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                    api.sendRequest(
                      UpdateAPIEnd,
                      () => {
                        setRefresh((prev) => !prev);
                      },
                      { isAutoApproval: val },
                      `Auto Approval ${val ? "Enable" : "Disable"} Successfully`
                    );
                  },
                })}
              </div>
              <div className="my-5 font-medium flex  items-center gap-2">
                Affiliate Share
                {RenderToggleButton({
                  checked: !userData?.isAffiliateEnable,
                  id: userData?.id,
                  size: "small",
                  isDisable: PERMISSION[accessPermission] === "READ",
                  onClick: (id, val) => {
                    const UpdateAPIEnd = { ...CONSTANTS?.API.user.update };
                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                    api.sendRequest(
                      UpdateAPIEnd,
                      () => {
                        setRefresh((prev) => !prev);
                      },
                      { isAffiliateEnable: val },
                      `Affiliate ${
                        val ? "Activate" : "Deactivate"
                      } Successfully`
                    );
                  },
                })}
              </div>
              <div className="my-5 font-medium flex  items-center gap-2">
                Refer & Earn
                {RenderToggleButton({
                  checked: !userData?.isReferAndEarnEnable,
                  id: userData?.id,
                  size: "small",
                  isDisable: PERMISSION[accessPermission] === "READ",
                  onClick: (id, val) => {
                    const UpdateAPIEnd = { ...CONSTANTS?.API.user.update };
                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                    api.sendRequest(
                      UpdateAPIEnd,
                      () => {
                        setRefresh((prev) => !prev);
                      },
                      { isReferAndEarnEnable: val },
                      `Affiliate ${
                        val ? "Activate" : "Deactivate"
                      } Successfully`
                    );
                  },
                })}
              </div>
              <div className="my-5 font-medium flex  items-center gap-2">
                Referral Earning (%)
                {RenderToggleButton({
                  checked: !userData?.isPercentageReferralEarningEnable,
                  id: userData?.id,
                  size: "small",
                  isDisable: PERMISSION[accessPermission] === "READ",
                  onClick: (id, val) => {
                    const UpdateAPIEnd = { ...CONSTANTS?.API.user.update };
                    UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                    api.sendRequest(
                      UpdateAPIEnd,
                      () => {
                        setRefresh((prev) => !prev);
                      },
                      { isPercentageReferralEarningEnable: val },
                      `Referral Earning(%) ${
                        val ? "Activate" : "Deactivate"
                      } Successfully`
                    );
                  },
                })}
              </div>
              <div className="my-5 font-medium flex  items-center gap-2">
                Block Device
                {RenderToggleButton({
                  checked: !isDeviceBlock,
                  id: userData?.id,
                  size: "small",
                  isDisable: PERMISSION[accessPermission] === "READ",
                  onClick: (id, val) => {
                    api.sendRequest(
                      CONSTANTS?.API.Device_Management.update,
                      () => {
                        setRefresh((prev) => !prev);
                      },
                      { isBlocked: val, deviceId: userData?.deviceId },
                      `Device ${val ? "Block" : "Unblock"} Successfully`
                    );
                  },
                })}
              </div>
              <div className="my-5 font-medium flex  items-center gap-2">
                Block User
                {RenderToggleButton({
                  checked: !userData?.isBlocked,
                  id: userData?.id,
                  isDisable: PERMISSION[accessPermission] === "READ",
                  size: "small",
                  onClick: (id, val) => {
                    val ? setOpenResonModal(id) : OnFormSubmitBtn(id);
                  },
                })}
              </div>
              <div className="font-medium">
                <span className="text-[#A8B0B8]">Block Reason :&nbsp;</span>
                {userData?.blockReason}
              </div>
            </Col>
          </Row>
          <Row className="">
            <Col span={6}>
              <div className="font-medium">
                <span className="text-[#A8B0B8]">PinCode :&nbsp;</span>
                {userData?.pinCode}
              </div>
            </Col>
            <Col span={6}>
              <div className="font-medium">
                <span className="text-[#A8B0B8]">City :&nbsp;</span>
                {userData?.city}
              </div>
            </Col>
            <Col span={6}>
              <div className="font-medium">
                <span className="text-[#A8B0B8]">State :&nbsp;</span>
                {userData?.state}
              </div>
            </Col>
            <Col span={6}>
              <div className="font-medium">
                <span className="text-[#A8B0B8]">Country :&nbsp;</span>
                {userData?.country}
              </div>
            </Col>
          </Row>
        </Card>
        <Row gutter={[24, 16]} className="my-5">
          <Col span={12}>
            <Card className="h-full">
              <div className="flex justify-between items-center">
                <p className="font-medium text-2xl">Tags</p>
                {/* <div className="font-medium text-[#A8B0B8]">
                  Available Spin :&nbsp;
                  <span className="text-black text-2xl">
                    {userData?.spinAvailable || 0}
                  </span>
                </div> */}
              </div>
              {userData?.tags &&
                userData?.tags?.split(",")?.map((ele) => (
                  <div
                    key={ele?.id}
                    className="font-medium bg-[#DBECFF80] inline-block px-3 py-2 mt-2 me-2 mb-1  rounded-[30px]"
                  >
                    {ele}
                  </div>
                ))}
              {/* <div className="mt-10 flex justify-between items-center">
                <TfiWallet color="#007BFF" size={40} />
                <p className="font-medium text-xl">
                  ₹
                  <span className="text-4xl">
                    &nbsp;{userData?.walletBalance || 0}
                  </span>
                </p>
              </div> */}
            </Card>
          </Col>
          <Col span={12}>
            <Card className="h-full">
              <div className="">
                <p className="font-medium text-2xl">Bank Details</p>
                <div className="mt-2">
                  <Row className="w-full">
                    <div className="font-medium">
                      <span className="text-[#A8B0B8]">
                        Accont Holder :&nbsp;
                      </span>
                      {userData?.beneficiaryName}
                    </div>
                  </Row>
                  <Row className="w-full">
                    <Col span={12}>
                      <div className="font-medium">
                        <span className="text-[#A8B0B8]">Account :&nbsp;</span>
                        {userData?.bankAccountNumber}
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="font-medium">
                        <span className="text-[#A8B0B8]">IFSC :&nbsp;</span>
                        {userData?.IFSCCode}
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* <div className="flex items-center gap-3">
                  <div className="font-medium flex  items-center gap-2">
                    <Select
                      value={userData?.isGovermentIdVerified}
                      disabled={PERMISSION[accessPermission] === "READ"}
                      style={{
                        width: 125,
                      }}
                      onChange={(val) => {
                        const UpdateAPIEnd = { ...CONSTANTS?.API.user.update };
                        UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                        api.sendRequest(
                          UpdateAPIEnd,
                          () => {
                            setRefresh((prev) => !prev);
                          },
                          { isGovermentIdVerified: val },
                          `Verification Status Updated Successfully`
                        );
                      }}
                      options={[
                        {
                          value: "Not Verified",
                          label: "Not Verified",
                        },
                        {
                          value: "Pending",
                          label: "Pending",
                        },
                        {
                          value: "Verified",
                          label: "Verified",
                        },
                        {
                          value: "Failed",
                          label: "Failed",
                        },
                      ]}
                    />
                  </div>
                </div> */}
              </div>
              {/* <div className="my-5 flex justify-between items-center">
                <div className="font-medium text-[#A8B0B8]">
                  Aadhar Card :&nbsp;
                  <span className="text-black ">
                    {userData?.adharCardNumber || "N/A"}
                  </span>
                </div>
                <div className="font-medium text-[#A8B0B8]">
                  PAN Card :&nbsp;
                  <span className="text-black ">
                    {userData?.panCardNumber || "N/A"}
                  </span>
                </div>
              </div>
              <div className=" flex justify-between items-center">
                <div className="font-medium text-[#A8B0B8]">
                  UPI ID :&nbsp;
                  <span className="text-black l">{userData?.UPI || "N/A"}</span>
                </div>
                <div className="cursor-pointer">
                  <EyeOutlined
                    className={`text-xl`}
                    onClick={() => {
                      const documentList = [
                        userData?.idCard,
                        userData?.aadharCard,
                        userData?.aadharCardBack,
                        userData?.panCard,
                      ].filter((url) => url !== null && url !== undefined);
                      documentList?.length
                        ? setDocList(documentList)
                        : notification.warning({
                            message: "Data Not Found",
                            duration: "3",
                          });
                    }}
                  />
                </div>
              </div> */}
            </Card>
          </Col>
        </Row>
        <Card className="my-5">
          <Tabs
            className="p-0 m-0"
            size="middle"
            type="card"
            items={CONSTANTS.TAB_MENU.USER.map((ele) => {
              return {
                label: `${ele.Label}`,
                key: `${ele.id}`,
                children: menus[ele?.id],
              };
            })}
          />
        </Card>
      </div>
      <Modal
        title={"View Documents"}
        centered
        open={docList}
        onCancel={() => {
          setDocList(null);
        }}
        width={800}
        footer={null}
      >
        <WorkProof MultipleImages={docList} />
        <div className="flex justify-end mt-5 items-center">
          Verification
          <Switch
            size={"small"}
            className="ms-2"
            onChange={(val) => {
              const UpdateAPIEnd = {
                ...CONSTANTS?.API.user.update,
              };
              UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${userData?.id}`;
              api.sendRequest(
                UpdateAPIEnd,
                () => {
                  setRefresh((prev) => !prev);
                },
                { isGovermentIdVerified: val ? "Verified" : "Not Verified" },
                `Verification Updated Successfully`
              );
            }}
            defaultChecked={userData?.isGovermentIdVerified === "Verified"}
            disabled={PERMISSION[accessPermission] === "READ"}
          />
        </div>
      </Modal>
      <ModalFormCreator
        loading={api.isLoading}
        open={openResonModal}
        onCreate={OnFormSubmitBtn}
        onCancel={() => {
          setOpenResonModal(null);
        }}
        menuFields={CONSTANTS.FORM_FIELD.USER_BLOCK_FORM}
        name={"Reason"}
        SubmitName={"Submit"}
      />
    </>
  );
};

export default UserDetail;
